import Error from "../../../components/Error";
import { useLogin } from "./modules/useLogin";

function LoginsTemplate() {
  const {
    email,
    password,
    setEmail,
    setPassword,
    loading,
    error,
    rememberMe,
    setRememberMe,
    handleLogin,
  } = useLogin();

  return (
    <div>
      {loading && <h2>Loading...</h2>}
      {error && <Error message="Invalid User" />}
      <div className="row justify-content-center mt-5 mb-5">
        <div className="col-md-5">
          <div className="bs">
            <h1>Login Screen</h1>
            <input
              type="email"
              className="form-control"
              placeholder="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
            <input
              type="password"
              className="form-control"
              placeholder="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />
            <div className="form-check mt-2">
              <input
                className="form-check-input"
                type="checkbox"
                id="rememberMe"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="rememberMe">
                Remember me
              </label>
            </div>
            <button className="btn btn-primary mt-3" onClick={handleLogin}>
              Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginsTemplate;
